import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';
import { SnotifyService, ToastDefaults } from 'ng-snotify';
import { trigger, transition, style, animate, state, stagger } from '@angular/animations';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'CTSWebApp';
  isAuthed: boolean = false;
  firstname:string = '';
  lastname: string = '';
  openNavs = [];
  userProfileId: number = 9;
  constructor(private authService: AuthService, private snotifyService: SnotifyService) {
    snotifyService.config = ToastDefaults;
    this.authService.currentUser.subscribe((currentUser) => {
      this.isAuthed = this.authService.isAuthed();
      if (this.isAuthed && currentUser != null && currentUser != undefined) {
        this.firstname = currentUser.firstname;
        this.lastname = currentUser.lastname;
        this.userProfileId = currentUser.userProfileId;
      }
      //if (this.authService.currentUser.value.userProfileId != 1) {
      //  //user is a client, so throw them to the reports page
      //  this.router.navigate(['reports/rote']);
      //}
    });
  }

  logout() {
    this.authService.logout();
  }

  setNav(nav) {
    if (this.openNavs.includes(nav)) {
      let idx = this.openNavs.indexOf(nav);
      this.openNavs.splice(idx, 1);
      return;
    }

    this.openNavs.push(nav);
  }

  isNavOpen(nav) {
    return this.openNavs.includes(nav);
  }
}
